module.exports = __webpack_public_path__ + "media/images/question_icon-11b68685abf762a33883d5e66f301b59.png";